// TIP-609 — the dotted pill beside the business name. One component for all
// four labels the design uses: Claimed, Member, Not claimed, Claim in review.
import React from "react";
import "./counterpartyBriefs.css";

const CbPill = ({ variant, label, testId }) => (
  <span data-testid={testId} className={`cb-pill cb-pill--${variant}`}>
    <span className="cb-pill-dot" />
    {label}
  </span>
);

export default CbPill;
